import { render, staticRenderFns } from "./DuplicatedPatientsSelectiveExport.vue?vue&type=template&id=302f6bd6&"
import script from "./DuplicatedPatientsSelectiveExport.vue?vue&type=script&lang=js&"
export * from "./DuplicatedPatientsSelectiveExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports